<script lang="ts">
	import { storeSnackbar } from '$lib/js/stores'
	import { onMount } from 'svelte'

	onMount(() => {
		// Automatically hide the snackbar after 7 seconds
		setTimeout(() => {
			storeSnackbar.update((snack) => ({ ...snack, show: false }))
		}, 7000)
	})

	interface Props {
		message: string;
	}

	let { message }: Props = $props();
</script>

<div class="snackbar">
	<span>{@html message}</span>
	<button class="icon icon-cross" onclick={() => ($storeSnackbar.show = false)}></button>
</div>

<style lang="scss">
	.snackbar {
		position: fixed;
		bottom: 20px;
		left: 50%;
		transform: translateX(-50%);
		background-color: #333;
		color: var(--white);
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.321);
		padding: 15px 25px;
		border-radius: 5px;
		transition: opacity 0.5s;
		opacity: 1;
		z-index: 9;
		min-width: 260px;
		text-align: center;
	}
	span {
		margin-right: 20px;
	}

	.icon-cross {
		color: var(--white);
	}
</style>
